export default __webpack_public_path__ + "static/media/gtDark.772ab3f3.PNG";